if (!customElements.get("video-loader")) {
    class VideoLoader extends HTMLElement {
      constructor() {
        super();
        // Ensure video plays when position absolute cuts off visible area
        let autoplayThreshold = 0.5;
        const dataRatio = parseFloat(this.dataset.ratio || '1');
        if (dataRatio > 0 && dataRatio < 1) {
          autoplayThreshold = dataRatio * 0.5;
        }

        this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
          root: null, // Use the viewport as the root
          threshold: autoplayThreshold, // Trigger when threshold of the element is visible
        });
      }

      connectedCallback() {
        this.observeVideos();
      }

      // Define a function to observe videos within the custom element and load them when they become visible
      observeVideos() {
        const videos = this.querySelectorAll("video");

        videos.forEach((video) => {
          this.intersectionObserver.observe(video);

          video.setAttribute("data-paused", "false");

          video.addEventListener("pause", (event) => {
            video.setAttribute("data-paused", "true");
          });
        });
      }

      // Handle the intersection changes (when videos become visible/invisible)
      handleIntersection(entries, observer) {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            const sources = video.querySelectorAll("source[data-src]");

            sources.forEach((source) => {
              source.src = source.getAttribute("data-src");
            });

            if (video.getAttribute("data-paused") == "false") {
              video.load();
            } else {
              if (entry.target.getAttribute("autoplay") === "autoplay") {
                video.setAttribute("data-paused", "false");
                video.play();
              }
            }

            video.onloadeddata = function () {
              if (entry.target.getAttribute("autoplay") === "autoplay") {
                video.setAttribute("data-paused", "false");
                video.play();
              }
            };
            // Unobserve the video once it's loaded
            // observer.unobserve(video);
          } else {
            video.pause();
          }
        });
      }

      // Clean up the Intersection Observer when the element is removed from the DOM
      disconnectedCallback() {
        this.intersectionObserver.disconnect();
      }
    }

    customElements.define("video-loader", VideoLoader);
}

if (!customElements.get("video-loader-button")) {
  class VideoLoaderButton extends HTMLElement {
    videoElement = null;
    videoElementId = null;

    constructor() {
      super();
      this.videoElementId = this.getAttribute("video-id");
      this.videoElement = document.getElementById(this.videoElementId);
    }

    connectedCallback() {
      if (!this.videoElement) {
        return;
      }

      this.addEventListener("click", this.handleClick);

      this.videoElement.addEventListener("play", () => {
        this.addHideClass();
      });

      this.videoElement.addEventListener("pause", () => {
        this.removeHideClass();
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }

    handleClick(event) {
      if (this.videoElement) {
        this.videoElement.load();
        this.videoElement.play();
      }
    }

    addHideClass() {
      this.parentElement.classList.add("video-loader-button--hidden");
    }

    removeHideClass() {
      this.parentElement.classList.remove("video-loader-button--hidden");
    }
  }

  customElements.define("video-loader-button", VideoLoaderButton);
}